import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { EstadoCivilEnum } from "core/resources/types/pessoa";

const { Option } = Select;

export interface SelectEstadoCivilProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  genero?: "m" | "f" | "o";
}

function SelectEstadoCivil({ value, genero, ...rest }: SelectEstadoCivilProps) {
  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      {...rest}
    >
      <Option value={EstadoCivilEnum.Solteiro} key={EstadoCivilEnum.Solteiro}>
        {genero === "f" ? "Solteira" : "Solteiro"}
      </Option>
      <Option value={EstadoCivilEnum.Casado} key={EstadoCivilEnum.Casado}>
        {genero === "f" ? "Casada" : "Casado"}
      </Option>
      <Option value={EstadoCivilEnum.Viuvo} key={EstadoCivilEnum.Viuvo}>
        {genero === "f" ? "Viúva" : "Viúvo"}
      </Option>
      <Option
        value={EstadoCivilEnum.Divorciado}
        key={EstadoCivilEnum.Divorciado}
      >
        {genero === "f" ? "Divorciada" : "Divorciado"}
      </Option>
      <Option value={EstadoCivilEnum.Separado} key={EstadoCivilEnum.Separado}>
        {genero === "f" ? "Separada" : "Separado"}
      </Option>
    </SelectBaseAntd>
  );
}

export default SelectEstadoCivil;
